/* eslint-disable pantry/no-raw-colors */
export interface ColorClassName {
  aerialTableBackground: string;
  aerialTableForeground: string;
  backgroundColor: string;
  borderColor: string;
  serverTableIndicator: string;
  strokeColor: string;
  textColor: string;
  textFgColor?: string;
}

interface ColorToClassName {
  [propName: string]: ColorClassName;
}

// One for each color defined in _party-status-colors.scss
const colorToClassName: ColorToClassName = {
  amber: {
    aerialTableBackground: 'amber-status-aerial-table-background',
    aerialTableForeground: 'amber-status-aerial-table-foreground',
    backgroundColor: 'amber-status-background',
    borderColor: 'amber-status-border',
    serverTableIndicator: 'amber-status-server-table-indicator',
    strokeColor: 'amber-status-stroke',
    textColor: 'amber-status-text',
  },
  blue: {
    aerialTableBackground: 'blue-status-aerial-table-background',
    aerialTableForeground: 'blue-status-aerial-table-foreground',
    backgroundColor: 'blue-status-background',
    borderColor: 'blue-status-border',
    serverTableIndicator: 'blue-status-server-table-indicator',
    strokeColor: 'blue-status-stroke',
    textColor: 'blue-status-text',
  },
  lightblue: {
    aerialTableBackground: 'light-blue-status-aerial-table-background',
    aerialTableForeground: 'light-blue-status-aerial-table-foreground',
    backgroundColor: 'light-blue-status-background',
    borderColor: 'light-blue-status-border',
    serverTableIndicator: 'light-blue-status-server-table-indicator',
    strokeColor: 'light-blue-status-stroke',
    textColor: 'light-blue-status-text',
  },
  brown: {
    aerialTableBackground: 'brown-status-aerial-table-background',
    aerialTableForeground: 'brown-status-aerial-table-foreground',
    backgroundColor: 'brown-status-background',
    borderColor: 'brown-status-border',
    serverTableIndicator: 'brown-status-server-table-indicator',
    strokeColor: 'brown-status-stroke',
    textColor: 'brown-status-text',
  },
  red: {
    aerialTableBackground: 'red-status-aerial-table-background',
    aerialTableForeground: 'red-status-aerial-table-foreground',
    backgroundColor: 'red-status-background',
    borderColor: 'red-status-border',
    serverTableIndicator: 'red-status-server-table-indicator',
    strokeColor: 'red-status-stroke',
    textColor: 'red-status-text',
  },
  green: {
    aerialTableBackground: 'green-status-aerial-table-background',
    aerialTableForeground: 'green-status-aerial-table-foreground',
    backgroundColor: 'green-status-background',
    borderColor: 'green-status-border',
    serverTableIndicator: 'green-status-server-table-indicator',
    strokeColor: 'green-status-stroke',
    textColor: 'green-status-text',
  },
  tangerine: {
    aerialTableBackground: 'tangerine-status-aerial-table-background',
    aerialTableForeground: 'tangerine-status-aerial-table-foreground',
    backgroundColor: 'tangerine-status-background',
    borderColor: 'tangerine-status-border',
    serverTableIndicator: 'tangerine-status-server-table-indicator',
    strokeColor: 'tangerine-status-stroke',
    textColor: 'tangerine-status-text',
  },
  grey: {
    aerialTableBackground: 'grey-status-aerial-table-background',
    aerialTableForeground: 'grey-status-aerial-table-foreground',
    backgroundColor: 'grey-status-background',
    borderColor: 'grey-status-border',
    serverTableIndicator: 'grey-status-server-table-indicator',
    strokeColor: 'grey-status-stroke',
    textColor: 'grey-status-text',
  },
  darkgrey: {
    aerialTableBackground: 'dark-grey-status-aerial-table-background',
    aerialTableForeground: 'dark-grey-status-aerial-table-foreground',
    backgroundColor: 'dark-grey-status-background',
    borderColor: 'dark-grey-status-border',
    serverTableIndicator: 'dark-grey-status-server-table-indicator',
    strokeColor: 'dark-grey-status-stroke',
    textColor: 'dark-grey-status-text',
  },
  lavender: {
    aerialTableBackground: 'lavender-status-aerial-table-background',
    aerialTableForeground: 'lavender-status-aerial-table-foreground',
    backgroundColor: 'lavender-status-background',
    borderColor: 'lavender-status-border',
    serverTableIndicator: 'lavender-status-server-table-indicator',
    strokeColor: 'lavender-status-stroke',
    textColor: 'lavender-status-text',
  },
  lime: {
    aerialTableBackground: 'lime-status-aerial-table-background',
    aerialTableForeground: 'lime-status-aerial-table-foreground',
    backgroundColor: 'lime-status-background',
    borderColor: 'lime-status-border',
    serverTableIndicator: 'lime-status-server-table-indicator',
    strokeColor: 'lime-status-stroke',
    textColor: 'lime-status-text',
  },
  magenta: {
    aerialTableBackground: 'magenta-status-aerial-table-background',
    aerialTableForeground: 'magenta-status-aerial-table-foreground',
    backgroundColor: 'magenta-status-background',
    borderColor: 'magenta-status-border',
    serverTableIndicator: 'magenta-status-server-table-indicator',
    strokeColor: 'magenta-status-stroke',
    textColor: 'magenta-status-text',
  },
  mint: {
    aerialTableBackground: 'mint-status-aerial-table-background',
    aerialTableForeground: 'mint-status-aerial-table-foreground',
    backgroundColor: 'mint-status-background',
    borderColor: 'mint-status-border',
    serverTableIndicator: 'mint-status-server-table-indicator',
    strokeColor: 'mint-status-stroke',
    textColor: 'mint-status-text',
  },
  orange: {
    aerialTableBackground: 'orange-status-aerial-table-background',
    aerialTableForeground: 'orange-status-aerial-table-foreground',
    backgroundColor: 'orange-status-background',
    borderColor: 'orange-status-border',
    serverTableIndicator: 'orange-status-server-table-indicator',
    strokeColor: 'orange-status-stroke',
    textColor: 'orange-status-text',
  },
  pink: {
    aerialTableBackground: 'pink-status-aerial-table-background',
    aerialTableForeground: 'pink-status-aerial-table-foreground',
    backgroundColor: 'pink-status-background',
    borderColor: 'pink-status-border',
    serverTableIndicator: 'pink-status-server-table-indicator',
    strokeColor: 'pink-status-stroke',
    textColor: 'pink-status-text',
  },
  lightpink: {
    aerialTableBackground: 'light-pink-status-aerial-table-background',
    aerialTableForeground: 'light-pink-status-aerial-table-foreground',
    backgroundColor: 'light-pink-status-background',
    borderColor: 'light-pink-status-border',
    serverTableIndicator: 'light-pink-status-server-table-indicator',
    strokeColor: 'light-pink-status-stroke',
    textColor: 'light-pink-status-text',
  },
  purple: {
    aerialTableBackground: 'purple-status-aerial-table-background',
    aerialTableForeground: 'purple-status-aerial-table-foreground',
    backgroundColor: 'purple-status-background',
    borderColor: 'purple-status-border',
    serverTableIndicator: 'purple-status-server-table-indicator',
    strokeColor: 'purple-status-stroke',
    textColor: 'purple-status-text',
  },
  tan: {
    aerialTableBackground: 'tan-status-aerial-table-background',
    aerialTableForeground: 'tan-status-aerial-table-foreground',
    backgroundColor: 'tan-status-background',
    borderColor: 'tan-status-border',
    serverTableIndicator: 'tan-status-server-table-indicator',
    strokeColor: 'tan-status-stroke',
    textColor: 'tan-status-text',
  },
  turquoise: {
    aerialTableBackground: 'turquoise-status-aerial-table-background',
    aerialTableForeground: 'turquoise-status-aerial-table-foreground',
    backgroundColor: 'turquoise-status-background',
    borderColor: 'turquoise-status-border',
    serverTableIndicator: 'turquoise-status-server-table-indicator',
    strokeColor: 'turquoise-status-stroke',
    textColor: 'turquoise-status-text',
  },
  slate: {
    aerialTableBackground: 'slate-status-aerial-table-background',
    aerialTableForeground: 'slate-status-aerial-table-foreground',
    backgroundColor: 'slate-status-background',
    borderColor: 'slate-status-border',
    serverTableIndicator: 'slate-status-server-table-indicator',
    strokeColor: 'slate-status-stroke',
    textColor: 'slate-status-text',
  },
  yellow: {
    aerialTableBackground: 'yellow-status-aerial-table-background',
    aerialTableForeground: 'yellow-status-aerial-table-foreground',
    backgroundColor: 'yellow-status-background',
    borderColor: 'yellow-status-border',
    serverTableIndicator: 'yellow-status-server-table-indicator',
    strokeColor: 'yellow-status-stroke',
    textColor: 'yellow-status-text',
  },
};

const bentoColorToPantryColor = {
  amber: 'yellow',
  blue: 'cyan',
  ['light-blue']: 'cyan',
  lightblue: 'cyan',
  brown: 'brown',
  green: 'green',
  grey: 'gray',
  ['dark-grey']: 'gray',
  darkgrey: 'gray',
  lavender: 'magenta',
  lime: 'lime',
  magenta: 'magenta',
  mint: 'cyan',
  orange: 'orange',
  pink: 'pink',
  ['light-pink']: 'pink',
  lightpink: 'pink',
  purple: 'purple',
  red: 'red',
  slate: 'blue',
  tan: 'brown',
  tangerine: 'amber',
  turquoise: 'teal',
  yellow: 'yellow',
} as const;

export const PANTRY_PARTY_STATUS_COLORS = [
  'yellow',
  'cyan',
  'brown',
  'green',
  'gray',
  'magenta',
  'lime',
  'orange',
  'pink',
  'purple',
  'red',
  'blue',
  'amber',
  'teal',
] as const;

export type PantryPartyStatusColor = (typeof PANTRY_PARTY_STATUS_COLORS)[number];

const pantryColorToPantryClassName = Object.fromEntries(
  PANTRY_PARTY_STATUS_COLORS.map((color) => [
    color,
    {
      aerialTableBackground: `${color}-pantry-status-aerial-table-background`,
      aerialTableForeground: `${color}-pantry-status-aerial-table-foreground`,
      backgroundColor: `${color}-pantry-status-background`,
      borderColor: `${color}-pantry-status-border`,
      serverTableIndicator: `${color}-pantry-status-server-table-indicator`,
      strokeColor: `${color}-pantry-status-stroke`,
      textColor: `${color}-pantry-status-text`,
      textFgColor: `${color}-pantry-status-fg-text`,
    },
  ])
) as Record<PantryPartyStatusColor, ColorClassName>;

function isPantryPartyStatusColor(color: string): color is PantryPartyStatusColor {
  return PANTRY_PARTY_STATUS_COLORS.includes(color as PantryPartyStatusColor);
}

export function getPartyStatusColorClassNames(
  color: string,
  pantryColor: string | undefined,
  partyStatusRefreshEnabled: boolean
): Partial<ColorClassName> {
  if (!partyStatusRefreshEnabled) {
    return colorToClassName[color] || {};
  }

  return pantryColorToPantryClassName[getPartyStatusPantryColor(color, pantryColor)];
}

export function getPartyStatusPantryColor(
  color: string,
  pantryColor: string | undefined
): PantryPartyStatusColor {
  const configuredPantryColor =
    pantryColor && isPantryPartyStatusColor(pantryColor) ? pantryColor : undefined;
  const pantryColorFromLegacyField = isPantryPartyStatusColor(color)
    ? color
    : bentoColorToPantryColor[color as keyof typeof bentoColorToPantryColor];

  return configuredPantryColor || pantryColorFromLegacyField || 'green';
}

export { colorToClassName, bentoColorToPantryColor, pantryColorToPantryClassName };
